// removed by extract-text-webpack-plugin
module.exports = {"root":"_3nZNX","active":"_l80TR","isSticky":"_2YhUR","icon":"_1zc_X","title":"_3w90C","description":"_3rTfR","anchor":"_1zteN"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/SectionNavigationItem/SectionNavigationItem.scss
// module id = 1310
// module chunks = 3